import styled from 'styled-components';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import OpeningTimesListEntry from './OpeningTimesListEntry';

const Wrapper = styled.div`
  padding: 20px 15px;
  text-align: left;
  background-color: #ffffff;
  &:nth-child(odd) {
    background-color: #fafafb;
  }
`;

const SpecialOpeningDaysWrapper = styled.div`
  text-align: left;

  & > h3 {
    align-self: start;
    color: #000000;
    margin: 20px 15px 0px 15px;

    font-size: 15px;
    letter-spacing: 0.67;
    @media (min-width: 768px) {
      font-size: 17px;
      letter-spacing: 0.75;
    }
  }
`;

const dayNamesList = {
  MONDAY: 'Montag',
  TUESDAY: 'Dienstag',
  WEDNESDAY: 'Mittwoch',
  THURSDAY: 'Donnerstag',
  FRIDAY: 'Freitag',
  SATURDAY: 'Samstag',
  SUNDAY: 'Sonntag',
};

const dayOrder = Object.keys(dayNamesList);

const isToday = (dayKey) => {
  const isoMap = {
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
    SATURDAY: 6,
    SUNDAY: 0,
  };
  return dayjs().day() === isoMap[dayKey];
};

const dateIsToday = (givenDateAsMoment) => {
  const today = dayjs().startOf('day');
  return givenDateAsMoment.startOf('day').diff(today) === 0;
};

function OpeningTimesList({ openingTimesData, specialOpeningDays }) {
  return (
    <div>
      {dayOrder.map((dayKey) => {
        const dayName = dayNamesList[dayKey];
        const openingTimesArr = openingTimesData[dayKey] || [];
        return (
          <Wrapper key={dayKey}>
            <OpeningTimesListEntry
              dayName={dayName}
              isToday={isToday(dayKey)}
              openingTimesArr={openingTimesArr} // Rohdaten übergeben
            />
          </Wrapper>
        );
      })}
      {specialOpeningDays?.length > 0 && (
        <SpecialOpeningDaysWrapper>
          <h3>Abweichende Öffnungszeiten</h3>
          {specialOpeningDays.map((specialOpeningD, index) => (
            <Wrapper key={`${specialOpeningD._id}-${index}`}>
              <OpeningTimesListEntry
                dayName={dayjs(specialOpeningD.date).format('DD.MM.YYYY')}
                isToday={dateIsToday(dayjs(specialOpeningD.date))}
                isSpecialOpeningDay={true}
                openingTimesArr={specialOpeningD.closed ? [] : specialOpeningD.timeAsEpochMillis}
              />
            </Wrapper>
          ))}
        </SpecialOpeningDaysWrapper>
      )}
    </div>
  );
}

OpeningTimesList.propTypes = {
  openingTimesData: PropTypes.object.isRequired,
  specialOpeningDays: PropTypes.array,
};

export default OpeningTimesList;
